module.exports = __webpack_public_path__ + "static/media/90458c53.jpg";